/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { FragmentsDeliveryEnableDeliveryDeliveryStatusMutationRequest, FragmentsDeliveryEnableDeliveryDeliveryStatusMutationResponse, FragmentsDeliveryEnableDeliveryDeliveryStatusPathParams, FragmentsDeliveryEnableDeliveryDeliveryStatus401, FragmentsDeliveryEnableDeliveryDeliveryStatus403, FragmentsDeliveryEnableDeliveryDeliveryStatus404 } from "../models/FragmentsDeliveryEnableDeliveryDeliveryStatus";

export function getFragmentsDeliveryEnableDeliveryDeliveryStatusUrl(fragmentId: FragmentsDeliveryEnableDeliveryDeliveryStatusPathParams["fragmentId"]) {
  const res = { method: 'POST', url: `/fragments-delivery/v1/delivery/${fragmentId}/enable` as const }
  return res
}

/**
 * @description Enables delivery for a fragment and triggers delivery jobs for its existing assets
 * @summary Enable delivery for an existing fragment
 * {@link /fragments-delivery/v1/delivery/:fragmentId/enable}
 */
export async function fragmentsDeliveryEnableDeliveryDeliveryStatus(fragmentId: FragmentsDeliveryEnableDeliveryDeliveryStatusPathParams["fragmentId"], data: FragmentsDeliveryEnableDeliveryDeliveryStatusMutationRequest, config: Partial<RequestConfig<FragmentsDeliveryEnableDeliveryDeliveryStatusMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<FragmentsDeliveryEnableDeliveryDeliveryStatusMutationResponse, ResponseErrorConfig<FragmentsDeliveryEnableDeliveryDeliveryStatus401 | FragmentsDeliveryEnableDeliveryDeliveryStatus403 | FragmentsDeliveryEnableDeliveryDeliveryStatus404>, FragmentsDeliveryEnableDeliveryDeliveryStatusMutationRequest>({ method : "POST", url : getFragmentsDeliveryEnableDeliveryDeliveryStatusUrl(fragmentId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}